<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                <div class="row justify-content-center">
                    <div>
                        <p class="h2 page-title">Availment History</p>
                    </div>
                </div>
                
                <div style="overflow: auto; height:500px;" class="row justify-content-center phil-row-info scroll">
                    <table class="table table-striped table-bordered phil-table">
                        <thead style= "background-color: #4472C4;">
                            <tr>
                              <th scope="col">DATE AVAILED</th>
                              <th scope="col">PROVIDER NAME</th>
                              <th scope="col">DOCTOR NAME</th>
                              <th scope="col">DIAGNOSIS</th>
                              <th scope="col">AVAILMENT TYPE</th>
                              <th scope="col">PROCEDURE/TEST</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in HistoryContent" :key="item.Dateavailed">
                              <td>{{item.Dateavailed}}</td>
                              <td>{{item.ProviderName}}</td>
                              <td>{{item.DoctorName}}</td>
                              <td>{{item.Diagnosis}}</td>
                              <td>{{item.Nature}}</td>
                              <td>{{item.SvcDesc}}</td>
                            </tr>
                          </tbody>
                      </table>
                </div>
            
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <router-link to="/member-page"><a type="button" class="btn btn-primary btn-lg" style="margin-top: 25px;">BACK</a></router-link>
                </div>
            </div>
        </div>
        </section>
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'HistoryPage',
  data() {
    return {
      certNo: '',
      HistoryContent: [],
      error: false,
      loading: false

    }
  },
    async created() {
      this.loading = true
      this.TokenID = localStorage.getItem('TokenID')
      console.log(this.TokenID)
      this.certNo = localStorage.getItem('CertNo')
        
        const response = await axios.post('/api/?action=member-history', {
           TokenID: 'TokenID',
           CertNo: this.certNo
        }, 
        );
        
        console.log(response);
        this.HistoryContent=response.data
        this.loading = false
        
    }
  }



</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
